import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../components/ui/Icon';
import type { Suite, ModuleSpec } from '../data/types/platform';

export interface SecondaryNavProps {
  system: Suite;
  activeModuleId: string | null;
  open: boolean;
  toggle: () => void;
}

interface ModuleGroup {
  label: string;
  items: ModuleSpec[];
}

export function SecondaryNav({ system, activeModuleId, open, toggle }: SecondaryNavProps) {
  const navigate = useNavigate();
  const groups: ModuleGroup[] = [
    { label: 'ליבה — Phase 1',           items: system.modules.filter((m) => !m.phase) },
    { label: 'תובנות מתקדמות — Phase 2', items: system.modules.filter((m) => m.phase === 'P2') },
    { label: 'תכנון לבחירות — Phase 3',  items: system.modules.filter((m) => m.phase === 'P3') },
  ].filter((g) => g.items.length > 0);

  return (
    <aside className="sidenav sn-secondary">
      <div className="sn-head">
        <div className="sn-head-text">
          <div className="sn-system-eyebrow">{system.en}</div>
          <div className="sn-system-name">{system.he}</div>
        </div>
        <button
          className="sn-toggle"
          onClick={toggle}
          title={open ? 'כווץ' : 'פתח'}
          aria-label="פתח או כווץ תפריט מערכת"
          type="button"
        >
          <Icon name="panel-right-close" size={16} />
        </button>
      </div>

      <div className="sn-body">
        {groups.map((g, gi) => (
          <Fragment key={gi}>
            {groups.length > 1 && <div className="sn-section">{g.label}</div>}
            {g.items.map((m) => (
              <button
                key={m.id}
                className={'sn-item' + (activeModuleId === m.id ? ' active' : '')}
                onClick={() => navigate(`/system/${system.id}/${m.id}`)}
                type="button"
              >
                <span className="sn-marker" aria-hidden="true" />
                <span className="sn-label">{m.he}</span>
                {m.phase && <span className="sn-tag">{m.phase}</span>}
                {!m.phase && m.health === 'anomaly' && <span className="sn-status alert" />}
                {!m.phase && m.health === 'gap' && <span className="sn-status warn" />}
                <span className="sn-tip">{m.he}</span>
              </button>
            ))}
          </Fragment>
        ))}
      </div>

    </aside>
  );
}
